import { combineReducers, createStore, applyMiddleware } from 'redux';
import { createHistory, useBasename } from 'history';
import { syncHistoryWithStore, routerReducer } from 'react-router-redux';
import {
  loadTranslations,
  syncTranslationWithStore,
  I18n,
  i18nReducer,
} from 'react-redux-i18n';
import { I18n as coreTranslator } from 'vdlib';
import thunk from 'redux-thunk';
import { combineEpics, createEpicMiddleware } from 'redux-observable';

import AppEpics from './app/App.epics';
import AuctionsEpics from './auctions/Auctions.epics';
import DashboardEpics from './dashboard/Dashboard.epics';
import GaragesEpics from './garages/Garages.epics';
import PartiesEpics from './parties/Parties.epics';
import BidsEpics from './bids/Bids.epics';
import ReportsEpics from './reports/Reports.epics';

import { ROUTER_BASE_PATH } from 'lib/Env';
import translations from './i18n';

/* Reducers */
import AppReducer, { defaultState as AppDefaults } from './app/App.reducer';
import AuctionsReducer, {
  defaultState as AuctionsDefaults,
} from './auctions/Auctions.reducer';
import DashboardReducer, {
  defaultState as DashboardDefaults,
} from './dashboard/Dashboard.reducer';
import BidsReducer, { defaultState as BidsDefaults } from './bids/Bids.reducer';
import PartiesReducer, {
  defaultState as PartiesDefaults,
} from './parties/Parties.reducer';
import GaragesReducer, {
  defaultState as GaragesDefaults,
} from './garages/Garages.reducer';
import ReportsReducer, {
  defaultState as ReportsDefaults,
} from './reports/Reports.reducer';

const rootReducer = combineReducers({
  app: AppReducer,
  auctions: AuctionsReducer,
  dashboard: DashboardReducer,
  garages: GaragesReducer,
  bids: BidsReducer,
  parties: PartiesReducer,
  reports: ReportsReducer,
  routing: routerReducer,
  i18n: i18nReducer,
});

const defaultState = {
  app: AppDefaults,
  auctions: AuctionsDefaults,
  dashboard: DashboardDefaults,
  bids: BidsDefaults,
  parties: PartiesDefaults,
  garages: GaragesDefaults,
  reports: ReportsDefaults,
};

/* Observable Epics */
const epicMiddleware = createEpicMiddleware(
  combineEpics(
    AppEpics,
    AuctionsEpics,
    DashboardEpics,
    GaragesEpics,
    PartiesEpics,
    BidsEpics,
    ReportsEpics
  )
);

/* Middleware */
const middleware = applyMiddleware(epicMiddleware, thunk);

const Store =
  typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function'
    ? createStore(
        rootReducer,
        defaultState,
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(middleware)
      )
    : createStore(rootReducer, defaultState, middleware);

syncTranslationWithStore(Store);
Store.dispatch(loadTranslations(translations));
// TODO: Restore this
// const initialLang = VDGLOBALS.lang || 'el-GR';
const initialLang = 'el-GR';
Store.dispatch({
  type: '@@i18n/SET_LOCALE',
  locale: initialLang,
  norequest: true,
});

coreTranslator.setTranslator(I18n);

/* Router History */
const browserHistory =
  !ROUTER_BASE_PATH || ROUTER_BASE_PATH === '/'
    ? createHistory()
    : useBasename(createHistory)({ basename: ROUTER_BASE_PATH }); //eslint-disable-line

export const history = syncHistoryWithStore(browserHistory, Store);

export default Store;
